import {useContext} from "react";
import {UserAccountContext} from "../context/UserAccountContext.tsx";

export const useUserAccount = () => {
    return useContext(UserAccountContext);
}